module.exports = __webpack_public_path__ + "img/x3.47b50b9c.png";